import { APITypes } from '@streem/api';

export interface Setting extends APITypes.StreemApiSetting, SettingMeta {
    name: string;
}

export interface SettingMeta {
    label: string;
    description: string;
    superAdmin?: boolean;
    order: number;
    visible?: () => boolean;
    fieldType?: string;
    testId?: string;
    helpLinkHref?: string;
    helpLinkDataTestId?: string;
    /** hide the toggle for a setting. useful for integer type settings */
    hideToggle?: boolean;
}

export interface SettingsDictionary {
    [settingName: string]: APITypes.StreemApiSetting;
}

export interface SourceSettingsDictionary {
    [source: string]: SettingsDictionary;
}

export interface DisplayableSettingsDictionary {
    [key: string]: SettingMeta;
}

export function createCompanySettingsDictionary(
    settings: Readonly<APITypes.StreemApiSetting[]>,
): SettingsDictionary {
    return settings.reduce((humanFriendlySettings: SettingsDictionary, setting) => {
        // exclude any scoped settings
        if (setting.name && !Array.isArray(setting.filterToScope?.callSourceCodes)) {
            humanFriendlySettings[setting.name] = setting;
        }
        return humanFriendlySettings;
    }, {});
}

export function createSourceSettingsDictionary(
    settings: Readonly<APITypes.StreemApiSetting[]>,
): SourceSettingsDictionary {
    return settings.reduce(
        (acc: SourceSettingsDictionary, nextSetting: APITypes.StreemApiSetting) => {
            const callSourceCodes = nextSetting.filterToScope?.callSourceCodes;
            if (nextSetting.name && Array.isArray(callSourceCodes)) {
                callSourceCodes.forEach(source => {
                    if (!acc[source]) {
                        acc[source] = {};
                    }
                    acc[source][nextSetting.name] = nextSetting;
                });
            }
            return acc;
        },
        {},
    );
}
